import { Dropdown, IconButton, Tooltip } from 'platform/components';
import { Spinner } from 'platform/foundation';
import { Icon } from 'platform/foundation-tw';
import { match } from 'ts-pattern';
import { useState } from 'react';
import { suffixTestId, TestIdProps } from 'shared/web';
import { Preset } from '../../../../types/Api';
import { PresetButtonActions } from '../../../../types/PresetButtonActions';
import { PresetApiStateEnum } from '../../constants/PresetApiStateEnum';
export type PresetButtonProps = TestIdProps & {
  preset: Preset;
  active: boolean;
  unsaved: boolean;
  state: PresetApiStateEnum;
  rowCount: number | undefined;
  actions?: PresetButtonActions;
  isDisabled?: boolean;
  onClick: () => void;
};
export function PresetButton(props: PresetButtonProps) {
  const [hover, setHover] = useState<boolean>(false);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const stateIcon = match(props.state).with(PresetApiStateEnum.loading, () => <Spinner size="small" />).with(PresetApiStateEnum.success, () => <Icon value="action/check_circle" />).with(PresetApiStateEnum.error, () => <Icon value="alert/error" />).otherwise(() => null);
  const iconColorClass = match(props.state).with(PresetApiStateEnum.success, () => 'text-green-500').with(PresetApiStateEnum.error, () => 'text-red-500').otherwise(() => '');
  const wrapperBgClass = props.active ? 'bg-blue-500' : 'bg-gray-100';
  const wrapperHoverClass = !props.isDisabled && props.active ? 'hover:bg-blue-600' : 'hover:bg-gray-200';
  const wrapperTextClass = props.active ? 'text-white' : '';
  const buttonDisabledClass = props.isDisabled ? 'opacity-30 pointer-events-none' : '';
  const dropdownTranslateClass = (hover || dropdownOpen) && !props.isDisabled ? 'translate-x-[-5px]' : 'translate-x-[24px]';
  return <div role="group" className={`overflow-hidden relative inline-flex h-8 flex-shrink-0 rounded-full leading-8 cursor-pointer select-none max-w-[200px] px-2 ${wrapperBgClass} ${wrapperHoverClass} ${wrapperTextClass}`} data-testid={props['data-testid']} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {/* Icon slot — slides in from left */}
      <div className={`absolute left-0 top-1/2 w-4 h-4 pr-[6px] box-content transition-transform duration-200 cubic-bezier-[0.4,0.14,0.3,1] translate-x-[-24px] -translate-y-1/2 pl-0 ${iconColorClass}`}>
        <div className="flex">{stateIcon}</div>
      </div>

      <Tooltip placement="top" label={props.rowCount !== undefined ? `${props.preset.title} (${props.rowCount})` : props.preset.title} description={props.preset.description}>
        <button type="button" onClick={props.onClick} className={`flex-1 text-sm h-full whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-[200px] ${buttonDisabledClass}`}>
          {props.unsaved && '* '}
          {props.preset.title}
          {props.rowCount !== undefined ? ` (${props.rowCount})` : null}
        </button>
      </Tooltip>

      {props.actions && <div className={`absolute right-0 mt-1 w-6 min-w-[24px] p-0 h-6 bg-white cursor-pointer rounded-full overflow-hidden transition-transform duration-200 delay-100 ${dropdownTranslateClass}`}>
          <Dropdown isLazy strategy="fixed" data-testid={suffixTestId('preset-actions-dropdown', props)} dropdownControl={<IconButton size="small" icon="navigation/more_vert" data-testid={suffixTestId('actions', props)} />} onClose={() => setDropdownOpen(false)} onOpen={() => setDropdownOpen(true)}>
            {props.actions}
          </Dropdown>
        </div>}
    </div>;
}